<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header" *ngIf="!loading">
    <h4>
      {{ 'profiles.search.create-profile-tasks-header' | translate | titlecase }}
    </h4>
  </ng-template>
  <div class="mct-flex mct-row mct-justify-center mct-items-center"  >
    <wl-busy [show]="loading"></wl-busy>
  </div>
  <form #crudForm="ngForm">
    <div class="dialog-body-container">
      <wl-task-edit [task]="task" [allowProfileAssignment]="false"></wl-task-edit>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="show = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!crudForm.valid" (click)="save()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'profiles.search.create-profile-tasks-button' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
